<template>
  <div>
    <v-list-item dense v-if="this.cancelamento">
      <v-list-item-icon>
        <v-icon color="red">
          mdi-cancel
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Motivo cancelamento:</v-list-item-title>
        <v-list-item-subtitle>
          {{ this.cancelamento.motivo }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item dense>
      <v-list-item-icon>
        <v-icon color="primary">
          mdi-phone
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ this.cliente.celular | phone }}</v-list-item-title>
        <v-list-item-subtitle>Celular</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-icon>
        <v-btn icon link target="_blank" :href="whatsAppLink()">
          <v-icon>mdi-whatsapp</v-icon>
        </v-btn>
      </v-list-item-icon>
    </v-list-item>
    <v-list-item
      dense
      v-if="this.isRepeteSemanalmente()"
    >
      <v-list-item-icon>
        <v-icon color="primary">
          mdi-repeat
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          {{ this.tiposAgendamento[this.agendamento.agenda.tipo].description }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item
      dense
      v-else
    >
      <v-list-item-icon>
        <v-icon color="primary">
          mdi-repeat-off
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          {{ this.tiposAgendamento[this.agendamento.agenda.tipo].description }} repete
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item dense>
      <v-list-item-icon>
        <v-icon color="primary">
          mdi-clock-outline
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          {{ this.agendamento.agenda.horaInicio | time }} até
          {{ this.agendamento.agenda.horaFim | time }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item dense>
      <v-list-item-icon>
        <v-icon color="primary">
          mdi-calendar
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title v-if="this.isRepeteSemanalmente()">
          {{ this.agendamento.agenda.dataInicio | date }} até
          {{ this.agendamento.agenda.dataFim | date }}
        </v-list-item-title>
        <v-list-item-title v-else>
          {{ this.agendamento.agenda.dataInicio | date }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item
      dense
      v-if="this.agendamento.agenda.anotacao"
    >
      <v-list-item-icon>
        <v-icon color="primary">
          mdi-note-outline
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          {{ this.agendamento.agenda.anotacao }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item dense v-if="this.hasTags()">
      <v-list-item-icon>
        <v-icon color="primary">
          mdi-tag-outline
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
          <div align="left">
            <template v-for="tag in this.tags()">
              <v-chip
                :key="tag.id"
                v-text="tag.nome"
                :color="tag.cor"/>
            </template>
          </div>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>
<script>
import AgendamentoTipo from '@/enums/agendamento-tipo';

export default {
  data() {
    return {
      tiposAgendamento: AgendamentoTipo.keys,
    };
  },
  props: {
    agendamento: {
      type: Object,
    },
    cancelamento: {
      type: Object,
    },
  },
  methods: {
    whatsAppLink() {
      return `https://api.whatsapp.com/send?phone=+55${this.cliente.celular}`;
    },
    tags() {
      if (this.cliente && this.cliente.tags) {
        return this.cliente.tags;
      }
      return [];
    },
    hasTags() {
      return this.tags().length > 0;
    },
    isRepeteSemanalmente() {
      return this.agendamento.agenda.tipo === this.tiposAgendamento.SEMANALMENTE.key;
    },
  },
  computed: {
    cliente: {
      get() {
        if (this.agendamento && this.agendamento.agenda) {
          return this.agendamento.agenda.cliente;
        }
        return null;
      },
    },
  },
};
</script>
